import { defer } from 'lodash';
/* eslint-disable no-nested-ternary, no-shadow, consistent-return */
import ERROR_CODE from '../../modules/components/RatingForm/RatingErrorCodes';
import { setShouldUserReservationsUpdate } from '../../../../ui-kitchen/src/reducers/userSlice';
import { selectIsAuthenticated } from '../../../../ui-kitchen/src/reducers/authTokenSlice';
import { getUserReservations } from '../../../../ui-kitchen/src/api';
import { reservationsTransform } from '../../../../ui-kitchen/src/api/resyApiTransformer';
import { postRateReservation } from '../../../../ui-kitchen/src/api/api';
import Logger from '../../../../ui-kitchen/src/utils/logger';
import { getTranslation } from '../../../../ui-kitchen/src/providers/TranslationProvider';

angular
  .module('resyApp')
  .controller('RatingsCtrl', RatingsCtrl);

function RatingsCtrl($scope, $location, $rootScope, $translate, $window, Analytics) {
  const thisCtrl = this;
  const {
    auth_token, // eslint-disable-line camelcase
    resyToken,
    key,
    rating,
    venue,
  } = $location.search();

  thisCtrl.rating = rating;
  thisCtrl.tagsArray = [];
  thisCtrl.venue = null;
  thisCtrl.token = key;
  thisCtrl.submissionError = false;
  thisCtrl.alreadyRated = false;
  thisCtrl.loading = false;
  thisCtrl.showThanks = false;
  thisCtrl.showError = false;
  thisCtrl.errorStatus = null;
  thisCtrl.date = null;
  thisCtrl.submitRating = submitRating;

  $scope.metadata.description = '';

  const { dispatch, getState } = $rootScope.reduxStore;

  init();

  function init() {
    buildPageTitle(venue);
    loadReservation();
  }

  function loadReservation() {
    if (resyToken) {
      thisCtrl.loading = true;
      getUserReservations({ resy_token: resyToken })
        .then((data) => {
          const result = reservationsTransform(data);
          const reservation = result[0];
          thisCtrl.date = reservation?.day;
          thisCtrl.venue = reservation?.venue?.name;
          if (reservation?.rating) {
            Logger.error('[ratings] rating already submitted');
            thisCtrl.alreadyRated = true;
            thisCtrl.errorStatus = ERROR_CODE.alreadyRated;
            thisCtrl.showError = true;
          }
          thisCtrl.loading = false;
          defer(() => $scope.$apply());
        }, (err) => {
          Logger.error('[ratings] loadReservations Error:', err);
          thisCtrl.showError = true;
          thisCtrl.errorStatus = ERROR_CODE.generic;
          thisCtrl.loading = false;
          defer(() => $scope.$apply());
        });
    } else if (key || auth_token) { // eslint-disable-line camelcase
      thisCtrl.venue = venue;
      thisCtrl.date = null;
      thisCtrl.loading = false;
    } else {
      Logger.error('[ratings] resy token or key not found');
      thisCtrl.showError = true;
      thisCtrl.errorStatus = ERROR_CODE.generic;
      thisCtrl.loading = false;
    }
  }

  function submitRating({ rating, comments, tags }) {
    const payload = {
      rating,
      comments,
      tags,
    };

    /* eslint-disable camelcase */
    if (!!auth_token && typeof auth_token === 'string') {
      payload.authToken = auth_token;
    }
    /* eslint-enable camelcase */

    if (!!key && typeof key === 'string') {
      payload.uniqueKey = key;
    } else if (!!resyToken && typeof resyToken === 'string') {
      payload.resyToken = resyToken;
    } else {
      Logger.error('[ratings] Error: Missing a parameter');
      thisCtrl.showError = true;
      thisCtrl.errorStatus = ERROR_CODE.generic;
      thisCtrl.loading = false;
      return;
    }

    Analytics.event('submit rating', {
      rating_value: rating,
      rating_scale: 5,
      venue: thisCtrl.venue || venue,
      has_comment: !!comments,
      tag_count: tags?.length || 0,
    });

    postRateReservation(payload)
      .then(
        () => {
          if (selectIsAuthenticated(getState())) {
            dispatch(setShouldUserReservationsUpdate({ type: 'past' }));
          }

          thisCtrl.showThanks = true;
          $window.scrollTo(0, 0);

          defer(() => $scope.$apply());
        },
        (err) => {
          Logger.error('[ratings] rating submit Error:', err);
          if (err.status === 403) {
            thisCtrl.showError = true;
            thisCtrl.errorStatus = ERROR_CODE.timeLimit;
            thisCtrl.loading = false;
          } else {
            thisCtrl.showError = true;
            thisCtrl.errorStatus = ERROR_CODE.generic;
            thisCtrl.loading = false;
          }
          defer(() => $scope.$apply());
        }
      );
  }

  function buildPageTitle(venueName) {
    $scope.metadata.title = getTranslation({
      translationKey: 'titles.rate_venue',
      translationValues: { venueName },
      fallback: `Rate Your Experience at ${venueName} | ${$scope.titleBase}`,
    });
  }
}

export default () => {};
